import { Observable, ReplaySubject } from 'rxjs';
import { ViewContainerRef } from '@angular/core';

/**
 * @internal
 *
 * Mediator for receiving and emitting ViewContainerRef of modal and toast.
 */
export class PoprContainerMediator {
  private poprModalView$ = new ReplaySubject<ViewContainerRef>(1);
  private poprToastView$ = new ReplaySubject<ViewContainerRef>(1);

  onPoprModalView$(): Observable<ViewContainerRef> {
    return this.poprModalView$.asObservable();
  }

  onPoprToastView$(): Observable<ViewContainerRef> {
    return this.poprToastView$.asObservable();
  }

  set poprModalView(vcr: ViewContainerRef) {
    this.poprModalView$.next(vcr);
  }

  set poprToastView(vcr: ViewContainerRef) {
    this.poprToastView$.next(vcr);
  }

  disposePoprModalView(): void {
    this.poprModalView$.complete();
    this.poprModalView$.unsubscribe();
  }

  disposePoprToastView(): void {
    this.poprToastView$.complete();
    this.poprToastView$.complete();
  }
}
